<a (click)="toggle()">
  <i class="material-icons menu-icon">{{item().icon}}</i>

  <span class="title">{{item().translate | translate}}</span>

  <p class="sizing"></p>

  <i class="material-icons" id="arrow">keyboard_arrow_right</i>
</a>

<div class="children" [@slideInOut]="opened">
  @for (item of item().children; track item.id) {
    <app-navigation-item [item]="item" class="in-collapsable"></app-navigation-item>
  }
</div>